import withPage from '@lib/withPage';
import { createCustomer } from '@src/bigcommerce/api/customers/create-customer';
import Breadcrumb from '@src/components/home/breadcrumb';
import Page from '@src/components/page';
import * as customerActions from '@src/redux/actions/customer';
import parsePhoneNumber from 'libphonenumber-js';
import { findPhoneNumbersInText } from 'libphonenumber-js';
import Link from 'next/link';
import React from 'react';
import { connect } from 'react-redux';
import toast from 'react-hot-toast';
import SimpleReactValidator from 'simple-react-validator';

class Register extends Page {
	constructor(props) {
		super(props);
		this.signUp = this.signUp.bind(this);
		this.inputs = {};
		this._validateOnDemand = true;
		this.validator = new SimpleReactValidator({
			locale: 'en',
		});
		this.validationCheck = this.validationCheck.bind(this);
	}

	validationCheck(target) {
		this.inputs[target.target.id] = target.target.value;
		if (!this._validateOnDemand) return;
	}

	async signUpAPI(email, password, firstName, lastName, phoneNumber) {
		try {
			var result = await createCustomer({
				email,
				password,
				firstName,
				lastName,
				phoneNumber,
			});

			if (result) {
				await this.props.login({
					username: email,
					password: password,
				});
			}
		} catch (error) {
			{
				toast.error(error.message);
				// TODO: This would be nice place to log errors to some external service
			}
		}
	}

	async signUp() {
		var { password, email, phone_number, given_name, family_name } = this.inputs;
		this.setState({ error: null });

		if (this.validator.allValid()) {
			var googleNumber = findPhoneNumbersInText(phone_number, 'US');
			if (googleNumber.length > 0) {
				var parsed = parsePhoneNumber(googleNumber[0].number.number);
				phone_number = parsed ? parsed.number : phone_number;
			}

			this.signUpAPI(email, password, given_name, family_name, phone_number);
		} else {
			this.validator.showMessages();

			this.forceUpdate();
		}
	}

	signUpSuccess(username) {
		var { email, password } = this.inputs;
		toast.success('Account Created');
	}

	signUpError(err) {
		toast.error(err.message);
		let message = err.message || err;
		if (message.startsWith('Invalid phone number')) {
			// reference: https://docs.aws.amazon.com/cognito/latest/developerguide/user-pool-settings-attributes.html
			message =
				'Phone numbers must follow these formatting rules: A phone number must start with a plus (+) sign, followed immediately by the country code. A phone number can only contain the + sign and digits. You must remove any other characters from a phone number, such as parentheses, spaces, or dashes (-) before submitting the value to the service. For example, a United States-based phone number must follow this format: +14325551212.';
		}
	}

	render() {
		var { user } = this.props;
		if (!user || !user.email) {
			user = null;
		}

		return (
			<div>
				<Breadcrumb title={'create account'} />
				{(() => {
					return (
						<form
							onSubmit={e => {
								e.preventDefault();
								this.signUp();
							}}>
							<div className="page register">
								<div className="account-login-register">
									<div className="container">
										<div className="login-container">
											<h2>Register</h2>
											<div className="form-group">
												<input
													type="text"
													className="form-control"
													id="given_name"
													placeholder="First Name"
													required="required"
													onChange={target => this.validationCheck(target)}
												/>
											</div>
											{this.validator.message(
												'First Name',
												this.inputs.given_name,
												'required|string'
											)}

											<div className="form-group">
												<input
													type="text"
													className="form-control"
													id="family_name"
													placeholder="Last Name"
													required="required"
													onChange={target => this.validationCheck(target)}
												/>
											</div>
											{this.validator.message(
												'Last Name',
												this.inputs.family_name,
												'required|string'
											)}

											<div className="form-group">
												<input
													type="text"
													className="form-control"
													id="email"
													placeholder="Email"
													required="required"
													onChange={target => this.validationCheck(target)}
												/>
											</div>
											{this.validator.message('Email', this.inputs.email, 'required|string')}

											<div className="form-group">
												<input
													type="numeric"
													format="(###) ###-####"
													className="form-control"
													id="phone_number"
													placeholder="Phone Number"
													required="required"
													onChange={target => this.validationCheck(target)}
												/>
											</div>
											{this.validator.message(
												'Phone Number',
												this.inputs.phone_number,
												'required|phone'
											)}

											<div className="form-group">
												<input
													type="password"
													className="form-control"
													id="password"
													placeholder="Enter your password"
													required="required"
													onChange={target => this.validationCheck(target)}
												/>
											</div>
											{this.validator.message(
												'Password',
												this.inputs.password,
												'required|string'
											)}

											<button className="btn" type="submit">
												<i className="fad fa-user-plus"></i> Create Account
											</button>

											<div className="login">
												<h4>Already Have Account?</h4>
												<Link href={`/login`} as={`/login`}>
													<a className="btn secondary">
														Sign In{' '}
														<i className="far fa-chevron-right" aria-hidden="true"></i>
													</a>
												</Link>
											</div>
										</div>
									</div>
								</div>
							</div>
						</form>
					);
				})()}
			</div>
		);
	}
}

const mapStateToProps = state => ({
	user: state.customer,
});

const mapDispatchToProps = dispatch => ({
	login: payload => dispatch(customerActions.login(payload)),
});

export default withPage(connect(mapStateToProps, mapDispatchToProps)(Register));
